import { Box } from "@mui/material";

import { CARD_SX } from "./constants";
import { fmtCurrencyExact, fmtPct } from "./formatters";
import { CardTitle } from "./primitives";
import { ZoneStat } from "./zoneStats";

import type { TwoZoneMetrics } from "./twoZoneMetrics";

const MARKETED_SCOPE_LABEL = "of premium marketed this year";
const MOVED_ONTO_PREFERRED_HELP =
  "Premium that started on a non-preferred carrier and moved onto a preferred (Tier 1 or Tier 2) carrier this year.";
const KEPT_ON_PREFERRED_HELP =
  "Premium kept on a preferred (Tier 1 or Tier 2) carrier — carrier-tier retention, not client retention.";
const MOVED_TO_NON_PREFERRED_HELP =
  "Premium from the retention opportunity that ended up on a non-preferred carrier (after preferred wins and pending-preferred premium).";

type DecidedZoneCardProps = {
  decided: TwoZoneMetrics["decided"];
};

function marketedCapture(capturePercent: number): string {
  return `${fmtPct(capturePercent)} ${MARKETED_SCOPE_LABEL}`;
}

function DecidedZoneCard({ decided }: DecidedZoneCardProps): React.JSX.Element {
  return (
    <Box
      role="group"
      aria-label="Decided"
      sx={{ ...CARD_SX, flex: 1, minWidth: 0 }}
    >
      <CardTitle>Decided</CardTitle>
      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
        <ZoneStat
          label="Moved onto a preferred carrier"
          value={fmtCurrencyExact(decided.movedOntoPreferred.premium)}
          caption={marketedCapture(decided.movedOntoPreferred.capturePercent)}
          help={MOVED_ONTO_PREFERRED_HELP}
        />
        <ZoneStat
          label="Kept on a preferred carrier"
          value={fmtCurrencyExact(decided.keptOnPreferred.premium)}
          caption={marketedCapture(decided.keptOnPreferred.capturePercent)}
          help={KEPT_ON_PREFERRED_HELP}
        />
        <ZoneStat
          label="Moved to a non-preferred carrier"
          value={fmtCurrencyExact(decided.movedToNonPreferred.premium)}
          help={MOVED_TO_NON_PREFERRED_HELP}
        />
      </Box>
    </Box>
  );
}

export { DecidedZoneCard };
